import { InfoAdapter } from "./info";

export interface Tag {
    key: string; // in the form of "{type}:{parent1}: ... :{child}"
    value: InfoAdapter;
}

export enum TagType {
    Category = "category",
    Application = "application",
    Supplier = "supplier",
    Process = "process",
    Custom = "custom",
}
